module.exports = __webpack_public_path__ + "static/headshot-4-cropped-2-30421ede675d9d23f61ee61dd7778e35.jpg";